import { type JSX } from 'react';

import { IMAGE_GENERATION_RESOLUTION_OPTIONS, VIDEO_GENERATION_RESOLUTION_OPTIONS } from '../../_context/constants';
import { AI_TOOLKIT_CATEGORIES, type AiToolkitCategory } from '../../_context/types';
import { SelectField, SelectFieldProps } from './SelectField';

export interface ResolutionSelectFieldProps
    extends Omit<SelectFieldProps, 'label' | 'id' | 'options' | 'defaultValue'> {
    aiToolkitCategory: Extract<AiToolkitCategory, 'video-generation' | 'image-generation'>;
}

export const ResolutionSelectField = ({
    aiToolkitCategory,
    selectTriggerProps,
    ...rest
}: ResolutionSelectFieldProps): JSX.Element => {
    const options =
        aiToolkitCategory === AI_TOOLKIT_CATEGORIES.VIDEO_GENERATION
            ? VIDEO_GENERATION_RESOLUTION_OPTIONS
            : aiToolkitCategory === AI_TOOLKIT_CATEGORIES.IMAGE_GENERATION
              ? IMAGE_GENERATION_RESOLUTION_OPTIONS
              : [];

    return (
        <SelectField
            selectTriggerProps={{ name: 'resolution', ...selectTriggerProps }}
            {...rest}
            label="Resolution"
            id="resolution"
            name="resolution"
            options={options}
            defaultValue={options[0]?.value}
        />
    );
};
